import decode from "@/helpers/decode.js";
import Storage from "@/services/storage.js";

const storage = new Storage(window.localStorage);

const roles = {
  USER: 0,
  ADMINISTRATOR: 1,
  SALES_MANAGER: 2,
  ACCOUNT_MANAGER: 3,
  ACCOUNT_CLIENT: 4,
};

const rolesDict = [
  { value: roles.USER, text: "Пользователь" },
  { value: roles.ADMINISTRATOR, text: "Администратор" },
  { value: roles.SALES_MANAGER, text: "Менеджер по продажам" },
  { value: roles.ACCOUNT_MANAGER, text: "Менеджер по работе с клиентами" },
  { value: roles.ACCOUNT_CLIENT, text: "Клієнт" },
];

export default {
  login(token) {
    storage.set("token", token);

    const { exp } = decode(token);
    storage.set("expires", exp);
  },
  logout() {
    storage.remove("token");
    // localStorage.removeItem("refreshToken");
    storage.remove("user");
    storage.remove("expires");
  },
  loggedIn() {
    const tokenExist = !!storage.get("token");
    const tokenExpired = storage.get("expires") < Date.now() / 1000;

    return tokenExist && !tokenExpired;
  },
  setUser(user) {
    storage.set("user", user);
  },
  getToken() {
    return storage.get("token");
  },
  getRefreshToken() {
    return storage.get("refreshToken");
  },
  getUser() {
    if (!storage.get("user")) {
      return null;
    }
    return storage.get("user");
  },
  isClient(role) {
    return role === roles.ACCOUNT_CLIENT;
  },
  isAdmin() {
    const user = this.getUser();
    if (!user) {
      return false;
    }
    return user.role === roles.ADMINISTRATOR;
  },
  getRoleName(){
    const user = this.getUser();
    if (user.role === undefined){
      user.role = 0;
    }
    return rolesDict.find(r => r.value === user.role).text;
  },
  getRole() {
    const user = this.getUser();
    return user?.role ?? roles.USER;
  },
  isAccountClient() {
    const user = this.getUser();
    if (!user) {
      return false;
    }
    return user.role === roles.ACCOUNT_CLIENT;
  },
  roles,
  rolesDict,
};
